export default __webpack_public_path__ + "static/media/docClip.dd4f8c66.svg";